import { LoadingButton } from '@airship-platform/jam-web/components';
import { zodResolver } from '@hookform/resolvers/zod';
import Box from '@mui/material/Box';
import { FormProvider, useForm } from 'react-hook-form';
import DataCollectionFormDetails, {
  DataCollectionInputs,
  DataCollectionSurveySchema,
} from './DataCollectionDetails';

interface DataCollectionFormProps {
  isLoading: boolean;
  onSubmit: (data: DataCollectionInputs) => void;
}

const DataCollectionForm: React.FC<DataCollectionFormProps> = ({
  onSubmit,
  isLoading,
}) => {
  const dataCollectionForm = useForm<DataCollectionInputs>({
    resolver: zodResolver(DataCollectionSurveySchema),
    defaultValues: {
      notes: '',
      householdIncome: 0,
      householdSize: 1,
      householdOwner: 'rent',
      taxFilingStatus: 'hoh',
      zipCode: '',
    },
  });

  return (
    <FormProvider {...dataCollectionForm}>
      <Box
        component={'form'}
        onSubmit={dataCollectionForm.handleSubmit(onSubmit)}
        sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}
      >
        <DataCollectionFormDetails />

        <LoadingButton
          loading={isLoading}
          disabled={isLoading}
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 2 }}
        >
          Save
        </LoadingButton>
      </Box>
    </FormProvider>
  );
};

export default DataCollectionForm;
